module.exports = __webpack_public_path__ + "assets/manual_adultAccident-3bbd72610ebac8482d62a16e9be7747f.pdf";